module.exports = __webpack_public_path__ + "static/img/ywlr.c194eea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/ywlr.png
// module id = jShm
// module chunks = 1